import { Modal, Row } from "react-bootstrap";
import "./index.scss";

const DeclarationModal = (props) => {
  const { show, onHide, title, body } = props;
  return (
    <Modal 
    size="lg" 
    show={show} 
    onHide={onHide} 
    className="p-0 mt-0"
    centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="agreementContainer overflow-x-scroll theme-scrollbar">
        <div>
          <Row>
            {body ? 
            <p className="" dangerouslySetInnerHTML={{ __html: body}}></p>
            : <p className="d-flex justify-content-center w-100 ">No data found</p>}
          </Row>
          <Row className="agreementAligner">
            <button
              style={{
                width: "auto",
                marginRight: "4.5vw",
              }}
              className="btn btn-primary primary_button"
              onClick={onHide}
            >
              Okay
            </button>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeclarationModal;
